import axios from 'services/axios'
import {
  API_PROFILE,
  API_PROFILE_CHANGE_PASSWORD,
  API_PROFILE_VALIDATE_PASSWORD,
  API_PROFILE_DOWNLOAD_AVATAR,
  API_PROFILE_UPLOAD_AVATAR,
} from 'constants/endpoints'

// Helpers
import { encrypt } from 'helpers/hash'

/**
 * Get profile avatar
 *
 * @return {Blob}
 */
export const getProfileAvatar = async () => {
  try {
    // Load avatar
    const { data } = await axios.post(
      API_PROFILE_DOWNLOAD_AVATAR,
      {},
      {
        responseType: 'blob',
      }
    )

    return URL.createObjectURL(data)
  } catch (error) {
    return null
  }
}

/**
 * Get current profile
 *
 * @return {Object}
 */
export const getProfile = async () => {
  try {
    const profile = await axios.get(API_PROFILE, {
      // Prevent emit event 401 on error
      silent: true,
    })

    // Set avatar
    profile.avatar = profile.profilePhoto ? await getProfileAvatar() : null

    return profile
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Update profile avatar
 *
 * @return {Object}
 */
export const updateProfileAvatar = async (file) => {
  try {
    return await axios.post(API_PROFILE_UPLOAD_AVATAR, {
      file,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Change password
 *
 * @param {Object} form { email, data, companyId, vendorId }
 */

export const changePassword = async (form) => {
  try {
    await axios.post(API_PROFILE_CHANGE_PASSWORD, {
      email: form.email,
      data: encrypt(form.data),
      companyId: form.companyId,
      vendorId: form.vendorId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
/**
 * Validate password
 *
 * @param {Object} form { email, data, companyId, vendorId }
 */
export const validatePassword = async (form) => {
  try {
    await axios.post(API_PROFILE_VALIDATE_PASSWORD, {
      email: form.email,
      data: encrypt(form.data),
      companyId: form.companyId,
      vendorId: form.vendorId,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}
